import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: NSAI-6314 — false only on a closed-network deployment, where domain
// ownership cannot be proven: the DNS TXT challenge is an outbound lookup the
// network cannot make, so the server rejects both adding and verifying a
// domain. The SAML tab hides the "Verified domains" section entirely rather
// than offering an action whose every attempt ends in an error toast and a row
// stuck on "Pending". The server enforces the same condition, so this decides
// visibility, never access.
//
// Reads the NEGATIVE flag off /app-config and inverts it here, so a response
// that simply lacks the key — an older server, or a failed request — means
// "available" and the section keeps rendering as it did before this hook
// existed. On a cloud deployment that is the correct answer; in a closed
// network the server still refuses, which is the fail-safe direction for a
// switch that only hides UI.
//
// `isLoading` is folded in because `undefined` data means two different
// things, and only one of them is "available": still loading, or answered
// without the key. Without the guard a closed-network deployment would render
// the section for the first frame of a cold load and then yank it away — a
// flash of exactly the affordance this exists to remove. Hiding while the
// answer is unknown makes the section APPEAR once it arrives, which is what a
// loading surface should do, and an outright failure still falls through to
// available, since react-query clears `isLoading` on error too.
export const useDomainVerificationAvailable = (): boolean => {
  const { data, isLoading } = useAppConfig();

  return !isLoading && !data?.deployment.isDomainVerificationUnavailable;
};
